import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import CurrencyInput from '../../components/inputs/currency_input';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import UpdateRateCardMutation from '../../mutations/update_rate_card_mutation';
import DeleteRateCardMutation from '../../mutations/delete_rate_card_mutation.modern';
import DuplicateRateCardMutation from '../../mutations/duplicate_rate_card_mutation.modern';
import RateLineItem from '../../components/settings-rate-cards/settings_rate_line_item';
import * as tracking from '../../tracking';
import InputField from '../../components/inputs/input_field';
import SelectInput from '../../components/inputs/select_input';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import Util from '../../forecast-app/shared/util/util';
import {currencies, ELEMENT_TYPE} from '../../constants';
import HeaderBar from '../../forecast-app/shared/components/headers/header-bar/header_bar';
import NotFoundModal from '../modal/not_found_modal';
import {cloneDeep} from 'lodash';
import CreateRateMutation from '../../mutations/create_rate_mutation';
import UpdateRateMutation from '../../mutations/update_rate_mutation';
import DeleteRateMutation from '../../mutations/delete_rate_mutation';
import {trackPage, unregisterPageInfo} from '../../tracking/amplitude/TrackingV2';

class settingsRateCard extends Component {
	constructor(props) {
		super(props);
		if (props.viewer.company.rateCard) {
			this.state = {
				rateCardName: this.props.viewer.company.rateCard.name,
				defaultRate: this.props.viewer.company.rateCard.defaultRate || 0,
				gearMenuExpanded: false,
			};
		} else {
			this.state = {
				notFound: true,
			};
		}

		this.superPropertyChecksum = trackPage('Settings Rate Card');
	}

	componentDidMount() {
		// Segment
		tracking.trackPage('settings-rate-cards-rate-card');
	}

	componentWillUnmount() {
		unregisterPageInfo(this.superPropertyChecksum);
	}

	handleRateCardNameChange(value) {
		this.setState({rateCardName: value || ''});
	}

	handleDefaultRateChange(value) {
		this.setState({defaultRate: value || 0});
	}

	handleDefaultRateBlur() {
		Util.CommitMutation(
			UpdateRateCardMutation,
			{
				id: this.props.viewer.company.rateCard.id,
				defaultRate: this.state.defaultRate,
			},
			null,
			true
		);
	}

	handleRateCardNameBlur() {
		Util.CommitMutation(
			UpdateRateCardMutation,
			{
				id: this.props.viewer.company.rateCard.id,
				name: this.state.rateCardName,
			},
			null,
			true
		);
	}

	deleteRateCard() {
		const callbackPositive = _ => {
			const onSuccess = _ => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'rate-card.has-been-deleted'})});
				this.props.history.push('/settings/finance');
			};

			Util.CommitMutation(
				DeleteRateCardMutation,
				{
					id: this.props.viewer.company.rateCard.id,
					companyId: this.props.viewer.company.id,
				},
				onSuccess,
				true
			);
		};

		showModal({
			type: MODAL_TYPE.GENERIC_DELETION_WARNING,
			deleteCallback: callbackPositive,
		});
	}

	duplicateRateCard() {
		const onSuccess = () => {
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'rate-card.has-been-duplicated'})});
		};
		Util.CommitMutation(
			DuplicateRateCardMutation,
			{
				rateCardId: this.props.viewer.company.rateCard.id,
			},
			onSuccess,
			true
		);
	}

	closeGearMenu() {
		this.setState({gearMenuExpanded: false});
	}

	toggleGearMenu() {
		this.setState({gearMenuExpanded: !this.state.gearMenuExpanded});
	}

	handleRateCardCurrencyChange(selected) {
		if (selected.value !== this.props.viewer.company.rateCard.currency) {
			Util.CommitMutation(
				UpdateRateCardMutation,
				{
					id: this.props.viewer.company.rateCard.id,
					currency: selected.value,
				},
				null,
				true
			);
		}
	}

	closeModal() {
		//Trigger blur so that if any of the inputs is focused, we send the mutation
		if (document.activeElement) {
			document.activeElement.blur();
		}
		this.props.history.push('/settings/rate-cards');
	}

	getHeader() {
		const leftContent = [],
			rightContent = [];

		leftContent.push({type: ELEMENT_TYPE.BACK_BUTTON, onClick: this.props.history.goBack});

		return (
			<HeaderBar
				innerRef={div => (this.header_bar = div)}
				parentGroup={null}
				leftContent={leftContent}
				rightContent={rightContent}
			/>
		);
	}

	handleRateUpdate(rate, rateId, rateCardId, roleId, isNewRole) {
		if (isNewRole && rate !== null && rate !== '' && roleId !== null) {
			Util.CommitMutation(CreateRateMutation, {
				rate: rate,
				roleId: roleId,
				rateCardId: rateCardId,
			});
		} else if (rate === null || rate === '') {
			Util.CommitMutation(DeleteRateMutation, {
				id: rateId,
				rateCardId: rateCardId,
			});
		} else if (rateId) {
			Util.CommitMutation(UpdateRateMutation, {
				id: rateId,
				rate: rate,
			});
		}
	}

	render() {
		const {formatMessage} = this.props.intl;

		if (this.state.notFound) {
			return (
				<NotFoundModal
					title={formatMessage({id: 'settings.rate-card-not-found'})}
					message={formatMessage({id: 'settings.rate-card-not-found.info'})}
					closeModal={this.closeModal.bind(this)}
				/>
			);
		}

		let roles = cloneDeep(this.props.viewer.company.roles.edges);
		let rates = cloneDeep(this.props.viewer.company.rateCard.rates.edges);
		roles.map(role => {
			role.node.rate = null;
			rates.map(rate => {
				if (rate.node.role.id === role.node.id) {
					//Assign to role
					role.node.rate = rate;
					return true;
				}
				return false;
			});
			//Remove already assigned rates so there is less to loop through
			return (rates = rates.filter(rate => role.node.rate !== rate));
		});
		const currency_options = this.props.viewer.company.exchangeRates.edges.map(exchangeRate => {
			const currencyName = currencies.find(currency => currency.value === exchangeRate.node.currency);
			return {value: exchangeRate.node.currency, label: currencyName ? currencyName.label : exchangeRate.node.currency};
		});
		const currencyName = currencies.find(currency => currency.value === this.props.viewer.company.currency);
		currency_options.unshift({
			value: this.props.viewer.company.currency,
			label: currencyName ? currencyName.label : this.props.viewer.company.currency,
		});

		const projectsWithRatecard = this.props.viewer.projects.edges.filter(project =>
			project.node.rateCard ? project.node.rateCard.id === this.props.viewer.company.rateCard.id : null
		);
		const editDisabled = !!projectsWithRatecard.find(project => project.node.hasLockedPeriod);

		return (
			<div className="section-content settings-app settings-rate-card">
				{this.props.children}
				{this.getHeader()}
				<CustomScrollDiv>
					<div className="section-body">
						<div className="inner">
							<fieldset>
								<div className="flex-container">
									<div className="rate-card-middle">
										{this.props.viewer.company.rateCard.currency !== this.props.viewer.company.currency ? (
											<div className="top-container">
												<p className="description">
													<FormattedMessage id="settings_currencies.currencies_description" />
												</p>
											</div>
										) : null}
										<div className="top-controls">
											<div className="inputs-wrapper">
												<InputField
													cy={'rate-card-input-name'}
													label={formatMessage({id: 'settings.rate-card-name'})}
													type="text"
													placeholder={formatMessage({id: 'settings.rate-card-default-placeholder'})}
													value={this.state.rateCardName}
													onChange={this.handleRateCardNameChange.bind(this)}
													onBlur={this.handleRateCardNameBlur.bind(this)}
													autosize={true}
													locked={editDisabled}
												/>
												<SelectInput
													cy={'rate-card-currency'}
													label={formatMessage({id: 'settings.rate-card-currency'})}
													placeholder={''}
													options={currency_options}
													onChange={this.handleRateCardCurrencyChange.bind(this)}
													value={this.props.viewer.company.rateCard.currency}
													multi={false}
													locked={this.props.viewer.company.rateCard.isRateCardUsed || editDisabled}
													title={
														this.props.viewer.company.rateCard.isRateCardUsed
															? formatMessage({id: 'settings_rate_card.currency_locked_info'})
															: null
													}
												/>
												{editDisabled ? (
													<span className="currency-locked-info">
														{
															'This ratecard is used in a project with a locked period. Therefore, it can not be changed. It can still be duplicated.'
														}
													</span>
												) : this.props.viewer.company.rateCard.isRateCardUsed ? (
													<span className="currency-locked-info">
														{formatMessage({id: 'settings_rate_card.currency_locked_info'})}
													</span>
												) : null}
											</div>
											<div
												className="gear-menu"
												tabIndex="0"
												onBlur={this.closeGearMenu.bind(this)}
												onClick={this.toggleGearMenu.bind(this)}
											>
												<span className="gear-icon" />
												<div
													className={
														'gear-menu-drop-down ' +
														(this.state.gearMenuExpanded ? 'expanded' : 'collapsed')
													}
												>
													<ul className="settings-drop-down">
														<li className="option" onClick={this.duplicateRateCard.bind(this)}>
															<FormattedMessage id="common.duplicate" />
														</li>
														{editDisabled ? (
															<li
																className="option disabled"
																title="This option is disabled as the rate card is attached to a project with a locked retainer period."
															>
																<FormattedMessage id="common.delete" />
															</li>
														) : (
															<li className="option" onClick={this.deleteRateCard.bind(this)}>
																<FormattedMessage id="common.delete" />
															</li>
														)}
													</ul>
												</div>
											</div>
										</div>
										<table>
											<thead>
												<tr>
													<th>
														<FormattedMessage id="settings.rate-card-role" />
													</th>
													<th className="rate-header">
														<FormattedMessage id="common.rate" />
													</th>
												</tr>
											</thead>
											<tbody>
												<tr className="rate-card-row">
													<td className="lbl-default">
														<FormattedMessage id="settings.rate-card-default" />
													</td>
													<td>
														<CurrencyInput
															value={this.state.defaultRate}
															onChange={this.handleDefaultRateChange.bind(this)}
															onBlur={this.handleDefaultRateBlur.bind(this)}
															placeholder="0"
															currency={
																this.props.viewer.company.rateCard.currency
																	? this.props.viewer.company.rateCard.currency
																	: this.props.viewer.company.currency
															}
															allowDecimals={true}
															blurOnEnter={true}
															disabled={editDisabled}
														/>
													</td>
												</tr>
												{roles.map(role => (
													<RateLineItem
														cy={'role-name'}
														key={role.node.id}
														role={role.node}
														placeholder={
															this.state.defaultRate ? this.state.defaultRate.toString() : '0'
														}
														rate={role.node.rate}
														rateCardId={this.props.viewer.company.rateCard.id}
														currency={
															this.props.viewer.company.rateCard.currency
																? this.props.viewer.company.rateCard.currency
																: this.props.viewer.company.currency
														}
														disabled={editDisabled}
														handleRateUpdate={this.handleRateUpdate.bind(this)}
													/>
												))}
											</tbody>
										</table>
									</div>
								</div>
							</fieldset>
						</div>
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

settingsRateCard.propTypes = {};

export const settingsRateCardQuery = graphql`
	query settingsRateCard_Query($rateCardId: String!) {
		viewer {
			actualPersonId
			component(name: "settings_rate_card")
			...settingsRateCard_viewer @arguments(rateCardId: $rateCardId)
		}
	}
`;

graphql`
	fragment settingsRateCard_rate on Rate {
		id
		rate
		role {
			...settingsRateCard_role @relay(mask: false)
		}
	}
`;

graphql`
	fragment settingsRateCard_role on Role {
		id
		name
	}
`;

export default injectIntl(
	withRouter(
		createFragmentContainer(settingsRateCard, {
			viewer: graphql`
				fragment settingsRateCard_viewer on Viewer @argumentDefinitions(rateCardId: {type: "String!"}) {
					actualPersonId
					availableFeatureFlags {
						key
					}
					company {
						id
						currency
						roles(first: 10000) {
							edges {
								node {
									...settingsRateCard_role @relay(mask: false)
								}
							}
						}
						exchangeRates(first: 10000) {
							edges {
								node {
									id
									currency
								}
							}
						}
						rateCard(id: $rateCardId) {
							id
							name
							defaultRate
							currency
							isRateCardUsed
							rates(first: 10000) @connection(key: "RateCard_rates") {
								edges {
									node {
										...settingsRateCard_rate @relay(mask: false)
									}
								}
							}
						}
					}
					projects(first: 10000) {
						edges {
							node {
								id
								companyProjectId
								hasLockedPeriod
								hasInvoices
								rateCard {
									id
								}
							}
						}
					}
				}
			`,
		})
	)
);
